import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { CurrencyFormatPipe } from '../../../shared/pipes/currency-format.pipe';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { PeriodicityPricing } from '../../../core/api/models/periodicity-pricing';

@Component({
  selector: 'acs-payment-frequency-option-section',
  imports: [
    TranslatePipe,
    CurrencyFormatPipe,
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton
  ],
  templateUrl: './payment-frequency-option-section.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentFrequencyOptionSectionComponent {
  @Input({ required: true }) fc!: FormControl;
  @Input({ required: true }) periodicity!: PeriodicityPricing;
}
